import './App.scss';
import GithubSearch from "./components/GithubSearch/GithubSearch";

function App() {
  return <GithubSearch />;
}

export default App;
